const DEFAULT_PREFERENCE_REPORT_SECTIONS = [
  {
    reportSectionId: 1,
    enabled: true
  },
  {
    reportSectionId: 2,
    enabled: true
  },
  {
    reportSectionId: 3,
    enabled: true
  },
  {
    reportSectionId: 4,
    enabled: true
  },
  {
    reportSectionId: 5,
    enabled: true
  },
  {
    reportSectionId: 6,
    enabled: true
  },
  {
    reportSectionId: 7,
    enabled: true
  },
  {
    reportSectionId: 8,
    enabled: true
  },
  {
    reportSectionId: 9,
    enabled: true
  },
  {
    reportSectionId: 10,
    enabled: true
  },
  {
    reportSectionId: 11,
    enabled: false
  },
  {
    reportSectionId: 12,
    enabled: false
  },
  {
    reportSectionId: 13,
    enabled: false
  }
]

const DEFAULT_AU_REPORT_CODE = '00000000-0000-0000-0000-000000000001'
const DEFAULT_NZ_REPORT_CODE = '00000000-0000-0000-0000-000000000002'

const DEFAULT_REPORTS_AU = [
  'Property Details',
  'Estimated value',
  'Property history',
  'Suburb insights',
  'Property photos and floor plan',
  'Estimated rent',
  'Recent sales and listings',
  'Local schools details'
]

const DEFAULT_REPORTS_NZ = [
  'Property Details',
  'Estimated value',
  'Property history',
  'Property photos',
  'Recent sales and listings',
  'Suburb insights'
]

export {
  DEFAULT_PREFERENCE_REPORT_SECTIONS,
  DEFAULT_AU_REPORT_CODE, DEFAULT_NZ_REPORT_CODE,
  DEFAULT_REPORTS_AU, DEFAULT_REPORTS_NZ
}
